import React from "react";
import { useInstantSearch } from "react-instantsearch";
import { PageMessage } from "components/PageMessage";
import * as styles from "components/layout/Search/Results/Results.module.scss";
import { ReactComponent as Empty } from "components/layout/Search/assets/empty-light.svg";
import { useIsLoggedIn } from "hooks";

export const NoResultsBoundary = ({
  children,
}: { children: React.ReactNode }) => {
  const { scopedResults, indexUiState } = useInstantSearch();
  const isLoggedIn = useIsLoggedIn();

  const hasQuery = !!indexUiState.query;
  const hitsCount = (scopedResults || []).reduce((total, result) => {
    if (!result.results?.nbHits) return total;
    return total + result.results.nbHits;
  }, 0);

  const showEmptyPlaceholder = !hasQuery;
  const showNoResults = hasQuery && hitsCount === 0;

  /**
   * Note: if we conditionally render a filter, it causes an infinite loop (Pages has a filter...)
   * Algolia docs recommend setting children to hidden instead of destroying
   */
  return (
    <>
      {(showEmptyPlaceholder || showNoResults) && (
        <div className={styles.noResultsContainer}>
          <PageMessage
            className={styles.message}
            image={<Empty />}
            title={
              showEmptyPlaceholder
                ? "Looking for something?"
                : "No results found"
            }
            subTitle={
              <p className={styles.noResultsSubtitle}>
                {showEmptyPlaceholder
                  ? `Search for matches, runners, players, outrights${isLoggedIn ? ", pick'ems" : ""} and more`
                  : "Please try a new search term"}
              </p>
            }
          />
        </div>
      )}
      <div {...(showEmptyPlaceholder || showNoResults ? { hidden: true } : {})}>
        {children}
      </div>
    </>
  );
};
